/**
 * LRC Digital Systems - Google Analytics Event Tracking Helpers
 * Integrates with G-GN6722VYZ5 & GT-M34V8KDM
 */

export const GA_MEASUREMENT_ID = 'G-GN6722VYZ5';

// Helper to safely trigger GA gtag commands
export const trackEvent = (action: string, params?: Record<string, any>) => {
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', action, params);
  }
};

// Track specific Page View (especially useful for SPA React Router navigation)
export const trackPageView = (path: string, title?: string) => {
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('config', GA_MEASUREMENT_ID, {
      page_path: path,
      page_title: title || document.title,
    });
  }
};

// Track Form Submissions (Diagnostic, Subscription, Custom Build requests)
export const trackFormSubmit = (formName: string, status: 'success' | 'error', details?: Record<string, any>) => {
  trackEvent('form_submission', {
    form_name: formName,
    status: status,
    ...details,
  });
};

// Track Blog Reads (When user selects/views a specific blog post)
export const trackBlogView = (slug: string, title: string) => {
  trackEvent('view_item', {
    items: [{
      item_id: slug,
      item_name: title,
      item_category: 'Blog Post',
    }],
    content_type: 'blog_post',
    item_list_id: 'flow_theory_blog'
  });
};

// Track CTA clicks (e.g. Request Custom Build, Watch System, Begin Diagnostic)
export const trackCtaClick = (ctaName: string, destination: string) => {
  trackEvent('cta_click', {
    cta_name: ctaName,
    destination: destination,
  });
};
